import produce from 'immer';
import { UPDATE_EMAIL_SETTING, UPDATE_WEBVERSION_ENABLED, FETCH_CONTENT_SCHEMA_SUCCEEDED, UPDATE_CAN_SPAM_SETTINGS_SUCCESS, DELETE_CAN_SPAM_SETTING_SUCCESS, FETCH_SUBSCRIPTION_GROUPS_SUCCEEDED, UPDATE_CAN_SPAM_SETTING_ID } from 'ContentEditorUI/redux/actions/actionTypes';
import { CREATE_SMART_EMAIL_FIELD_DEFINITION, CREATE_SMART_EMAIL_FIELD_RULE, UPDATE_SMART_EMAIL_FIELD_RULES, UPDATE_SMART_EMAIL_FIELD_RULE, REMOVE_SMART_EMAIL_FIELD_DEFINITION } from 'EmailEditorUI/redux/actions/actionTypes';
import { REMOVE_EMAIL_ADDRESS_SUCCEEDED } from 'EmailData/actions/actionTypes';
import get from 'hs-lodash/get';
import set from 'hs-lodash/set';
import unset from 'hs-lodash/unset';
const initialState = {
  name: '',
  scrubsSubscriptionLinks: null,
  subcategory: '',
  subscription: null,
  subscriptionName: '',
  preferencesGroupId: null,
  transactional: false,
  replyTo: '',
  replyToUserId: null,
  customReplyTo: '',
  customReplyToEnabled: false,
  fromName: '',
  subject: '',
  language: '',
  useRssHeadlineAsSubject: false,
  previewText: '',
  createPage: false,
  headerFooterModules: false,
  emailbodyPlaintext: '',
  smartEmailFields: {},
  canSpamSettings: [],
  canSpamSettingsId: null,
  teamPerms: [],
  userPerms: []
};
const convertCriterionToSmartEmailFieldRule = (criterion, existingCriteria = []) => {
  const existingCriterion = existingCriteria.find(c => c.criterion_id === criterion.id);
  return {
    criterion_id: criterion.id,
    display_name: criterion.name || criterion.id,
    order: criterion.precedence,
    value: existingCriterion ? existingCriterion.value : ''
  };
};
const getSmartPathForField = field => ['smartEmailFields', field.toUpperCase()];
export const emailSettingsReducer = (state = initialState, action) => {
  return produce(state, draft => {
    let index;
    let oldCanSpamSettings;
    let newCanSpamSettings;
    switch (action.type) {
      case UPDATE_EMAIL_SETTING:
        {
          const {
            updatedProperties
          } = action;
          for (const i of Object.keys(updatedProperties)) {
            const path = i.split('-');
            set(draft, path, updatedProperties[i]);
            if (get(draft, ['smartEmailFields', path[0].toUpperCase()])) {
              set(draft, ['smartEmailFields', path[0].toUpperCase(), 'default_value'], updatedProperties[i]);
            }
          }
          return draft;
        }
      case UPDATE_CAN_SPAM_SETTING_ID:
        {
          draft.canSpamSettingsId = action.id;
          return draft;
        }
      case UPDATE_WEBVERSION_ENABLED:
        {
          draft.createPage = action.payload.createPage;
          return draft;
        }
      case REMOVE_EMAIL_ADDRESS_SUCCEEDED:
        {
          if (!action.isEmailVerified) {
            ['replyTo', 'customReplyTo'].forEach(field => {
              if (draft[field] === action.replyTo) {
                draft[field] = '';
              }
            });
          }
          return draft;
        }
      case FETCH_CONTENT_SCHEMA_SUCCEEDED:
        {
          const {
            content,
            can_spam_settings
          } = action.response;
          const properties = ['name', 'customReplyToEnabled', 'fromName', 'transactional', 'scrubsSubscriptionLinks', 'subcategory', 'subscription', 'subscriptionName', 'preferencesGroupId', 'subject', 'useRssHeadlineAsSubject', 'createPage', 'canSpamSettingsId', 'language', 'headerFooterModules'];
          properties.forEach(property => set(draft, property, content[property]));
          draft.replyTo = content.replyTo ? content.replyTo.toLowerCase() : content.replyTo;
          draft.replyToUserId = (content === null || content === void 0 ? void 0 : content.replyToUserId) || null;
          draft.customReplyTo = content.customReplyTo ? content.customReplyTo.toLowerCase() : content.customReplyTo;
          draft.emailbodyPlaintext = content.emailbodyPlaintext || '';
          draft.smartEmailFields = content.smartEmailFields || {};
          if (!draft.canSpamSettingsId) {
            draft.canSpamSettingsId = content.meta.can_spam_settings_id;
          }
          draft.canSpamSettings = can_spam_settings || [];
          return draft;
        }
      case UPDATE_CAN_SPAM_SETTINGS_SUCCESS:
        {
          const {
            id,
            data,
            groupId
          } = action;
          if (groupId) {
            return draft;
          }
          oldCanSpamSettings = draft.canSpamSettings.slice();
          index = oldCanSpamSettings.findIndex(item => item.id === id);
          if (index > -1) {
            set(oldCanSpamSettings, index, data);
          } else {
            oldCanSpamSettings.push(data);
          }
          newCanSpamSettings = oldCanSpamSettings;
          draft.canSpamSettings = oldCanSpamSettings;
          return draft;
        }
      case DELETE_CAN_SPAM_SETTING_SUCCESS:
        {
          const {
            groupId,
            id
          } = action;
          if (groupId) {
            return draft;
          }
          oldCanSpamSettings = draft.canSpamSettings.slice();
          index = oldCanSpamSettings.findIndex(item => item.id === id);
          if (index < 0) {
            return draft;
          }
          oldCanSpamSettings.splice(index, 1);
          newCanSpamSettings = oldCanSpamSettings;
          draft.canSpamSettings = newCanSpamSettings;
          return draft;
        }
      case FETCH_SUBSCRIPTION_GROUPS_SUCCEEDED:
        {
          const {
            payload
          } = action;
          if (Object.keys(payload).length === 1) {
            draft.preferencesGroupId = get(payload, [0, 'preferencesGroup', 'id']);
            return draft;
          }
          return draft;
        }
      case CREATE_SMART_EMAIL_FIELD_DEFINITION:
        {
          const {
            smartDefinition,
            targetId
          } = action;
          const smartFieldPath = getSmartPathForField(targetId);
          const {
            definition,
            initialCriterion
          } = smartDefinition;
          const newSmartDefinition = {
            default_value: get(draft, targetId.toLowerCase()),
            definition_id: definition.id,
            email_field: targetId,
            smart_objects: [convertCriterionToSmartEmailFieldRule(initialCriterion)]
          };
          set(draft, smartFieldPath, newSmartDefinition);
          return draft;
        }
      case UPDATE_SMART_EMAIL_FIELD_RULES:
        {
          const {
            smartCriteria,
            smartMetaData,
            targetId
          } = action;
          const smartRulesPath = [...getSmartPathForField(targetId), 'smart_objects'];
          const definitionIdPath = [...getSmartPathForField(targetId), 'definition_id'];
          const smartRules = get(draft, smartRulesPath);
          const updatedSmartRules = smartCriteria.map(c => convertCriterionToSmartEmailFieldRule(c, smartRules));
          set(draft, smartRulesPath, updatedSmartRules);
          set(draft, definitionIdPath, smartMetaData.definitionId);
          return draft;
        }
      case CREATE_SMART_EMAIL_FIELD_RULE:
        {
          if (!draft.smartEmailFields) {
            draft.smartEmailFields = {};
          }
          const {
            criterion,
            targetId
          } = action;
          const smartRulesPath = [...getSmartPathForField(targetId), 'smart_objects'];
          const currentSmartObjects = get(draft, smartRulesPath);
          currentSmartObjects.push(convertCriterionToSmartEmailFieldRule(criterion));
          set(draft, smartRulesPath, currentSmartObjects);
          return draft;
        }
      case REMOVE_SMART_EMAIL_FIELD_DEFINITION:
        {
          unset(draft, getSmartPathForField(action.targetId));
          return draft;
        }
      case UPDATE_SMART_EMAIL_FIELD_RULE:
        {
          const {
            targetId,
            criterionId,
            value
          } = action;
          const smartRulesPath = [...getSmartPathForField(targetId), 'smart_objects'];
          const smartRules = get(draft, smartRulesPath);
          if (smartRules) {
            const indexOfSmartRule = smartRules.findIndex(r => r.criterion_id === criterionId);
            if (indexOfSmartRule >= 0) {
              set(draft, [...smartRulesPath, indexOfSmartRule, 'value'], value);
            }
            return draft;
          }
          return draft;
        }
      default:
        return draft;
    }
  });
};
export default emailSettingsReducer;